// TODO: Replace these placeholders with real Stripe account data from the API
// once the backend integration story is implemented.
export const PLACEHOLDER_STRIPE_ACCOUNT_ID = "1RMtAOHBzxvSFGGk";
export const PLACEHOLDER_STRIPE_STEP_COMPLETED_DATE = "5/20/2025";

// TODO: Move to environment/runtime config once the real Stripe connect URL is
// available per environment.
export const STRIPE_ACCOUNT_URL = "https://stripe.com";

/** OEM-set Advanced Access Deposit shown as a disabled field. */
export const ADVANCED_ACCESS_DEPOSIT_DISPLAY = "$100";

const DEPOSIT_AMOUNT_INCREMENT = 100;

/**
 * Builds currency dropdown options in $100 increments (inclusive).
 * @param {number} min
 * @param {number} max
 * @returns {{ value: string, label: string }[]}
 */
export function buildDepositAmountOptions(min, max) {
  const options = [];
  for (let amount = min; amount <= max; amount += DEPOSIT_AMOUNT_INCREMENT) {
    options.push({
      value: String(amount),
      label: formatDepositAmountLabel(amount),
    });
  }
  return options;
}

/**
 * @param {number} amount
 * @returns {string}
 */
export function formatDepositAmountLabel(amount) {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  }).format(amount);
}

/**
 * Maps an API decimal deposit amount to a select value string.
 * @param {number|string|null|undefined} apiValue
 * @returns {string}
 */
export function mapDepositAmountFromApi(apiValue) {
  if (apiValue == null || apiValue === "") {
    return "";
  }
  const numericValue = Number(apiValue);
  if (Number.isNaN(numericValue)) {
    return "";
  }
  return String(Math.trunc(numericValue));
}

export const ORDER_DEPOSIT_OPTIONS = buildDepositAmountOptions(100, 1500);
export const MAX_CREDIT_CARD_OPTIONS = buildDepositAmountOptions(100, 3000);
export const MAX_ACH_OPTIONS = buildDepositAmountOptions(100, 100000);
export const CHECKOUT_DEPOSIT_OPTIONS = buildDepositAmountOptions(100, 3000);
